module.exports = __webpack_public_path__ + "static/media/header-home-biolitoral-2.eda62bd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/header-home-biolitoral-2.png
// module id = 666
// module chunks = 0